export var NAME_OPTIONS = {
  TICKETFLEXI: "TicketFlexi",
  TICKETSAVER: "TicketSaver",
  TICKETSTANDARD: "TicketStandard"
};
export var baseURL = "//images.kiwi.com";